import { RANKS } from "@/lib/simulator";

/**
 * Segmented F1..F20 progress track. Current rank glows.
 */
export default function RankTrack({ currentRank, nextRank, totalQV }) {
  const currentIdx = RANKS.findIndex((r) => r.rank === currentRank);

  return (
    <div>
      <div className="flex items-center gap-1 overflow-x-auto pb-1">
        {RANKS.map((r, i) => {
          const done = i <= currentIdx;
          const current = i === currentIdx;
          return (
            <div key={r.rank} className="flex-1 min-w-[24px] group relative">
              <div
                className={`h-2 rounded-sm transition-colors ${
                  done ? "" : "bg-white/[0.06]"
                }`}
                style={
                  done
                    ? {
                        background:
                          "linear-gradient(90deg,#F97316,#EC4899 60%,#A855F7)",
                        boxShadow: current
                          ? "0 0 18px rgba(236,72,153,0.65)"
                          : "none",
                      }
                    : undefined
                }
              />
              <div
                className={`mt-1 text-center text-[9px] font-mono ${
                  current
                    ? "text-white font-semibold"
                    : done
                    ? "text-slate-300"
                    : "text-slate-600"
                }`}
              >
                {r.rank}
              </div>
              <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-9 hidden group-hover:block z-20 whitespace-nowrap">
                <div className="glass rounded-md px-2 py-1 text-[10px] text-slate-200 border border-white/10">
                  {r.rank} · ${r.qv.toLocaleString()} QV
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {nextRank && (
        <div className="mt-3 flex flex-wrap items-center justify-between gap-x-2 gap-y-1 text-[11px] sm:text-xs">
          <div className="text-slate-400">
            Next: <span className="text-white font-medium">{nextRank.rank}</span> ·{" "}
            <span className="text-slate-400">{nextRank.unlock}</span>
          </div>
          <div className="font-mono text-slate-400">
            {Math.max(0, nextRank.qv - totalQV).toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
            })}{" "}
            <span className="text-slate-500">QV to go</span>
          </div>
        </div>
      )}
    </div>
  );
}
